import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class UrlService {
  private previousUrl: BehaviorSubject<string| null> = new BehaviorSubject<string | null>(null);
  public previousUrl$: Observable<string | null> = this.previousUrl.asObservable();

  constructor() {
  }

  setPreviousUrl(previousUrl: string) {
    this.previousUrl.next(previousUrl);
  }
}
